import React, { useState, useEffect } from "react";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import clsx from "clsx";
import TransformerForm from "./TransformerForm";
import TransformerList from "./TransformerList";
import TransformerDetails from "./TransformerDetails";
import ContractDetails from "./ContractDetails";
import AlertContact from "./AlertContact";
import CustomerContractDetails from "./CustomerContractDetails";
import { BreadcrumbPage } from "../../shared";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { getCookie } from "../../services/Cookies";
import { getRequest, postRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import { LOADING } from "../../action";
import { useDispatch } from "react-redux";
import Help from "@material-ui/icons/Help";
import { Box } from "@material-ui/core";
import CancelIcon from '@mui/icons-material/Cancel';
import ctrl from '../Helpsection_images/ctrl.jpg';
import clear from '../Helpsection_images/clear.jpg';
import cancel from '../Helpsection_images/cancel.jpg';
import applyfilter from '../Helpsection_images/applyfilter.jpg';
import ClearIcon from '@mui/icons-material/Clear';
import reset from '../Helpsection_images/reset.jpg';
import save from '../Helpsection_images/save.jpg';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    color: theme.palette.text.secondary,
  },
  gridSpacing: {
    margin: "0 !important",
    width: "100% !important",
  },
  btnFilters: {
    color: "#ff4717",
    border: "1px solid rgb(255 71 23)",
  },
}));
export default function TransformersMain(props) {
  const contacts = [
    {
      id: 1,
      shipName: "ATLANTA 1",
      shipSubName: "Assocoated Maritime Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 2,
      shipName: "ATLANTA 2",
      shipSubName: "Maerks",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 3,
      shipName: "ATLANTA 3",
      shipSubName: "XYZ",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      shipOwner: "Gulf",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 4,
      shipName: "ATLANTA 4",
      shipSubName: " Maritime Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 5,
      shipName: "ATLANTA 5",
      shipSubName: "Shell",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      shipOwner: "Gulf",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 6,
      shipName: "ATLANTA 6",
      shipSubName: "Fleet",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      shipOwner: "Gulf",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 7,
      shipName: "ATLANTA 7",
      shipSubName: "",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 8,
      shipName: "ATLANTA 8",
      shipSubName: " Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipOwner: "Gulf",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 9,
      shipName: "ATLANTA 9",
      shipSubName: "Assocoated Maritime Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      shipOwner: "Gulf",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
    {
      id: 10,
      shipName: "ATLANTA 10",
      shipSubName: "Assocoated Maritime Company (HK)",
      imo: "9324889",
      objNum: "V2FLB",
      shipOwner: "Gulf",
      flag: "Antigue & Barderna",
      operator: "BBC Charting& Logistic GmbH",
      shiptype: "General Cargo Ship",
      status: "Delivered",
      dwtRange: "30,300",
      shipyard: "China",
      classification: "DNVGL",
      yearBuilt: 2001,
    },
  ];
  const BreadcrumbList = [
    { name: "Assets", url: "/dashboard/assets" },
    { name: "Transformer Details", url: "/dashboard/assets" },
  ];
  const dispatch = useDispatch();
  const [shipList, setShipList] = useState([]);
  const [customerContractList, setCustomerContractList] = useState([]);
  const [contractList, setContractList] = useState([]);
  const [seletedShip, setSeletedShip] = useState([]);
  const [scroll, setScroll] = React.useState('paper');
  const [formOpen, setFormOpen] = React.useState(false);
  const [index, setIndex] = useState(0);
  const classes = useStyles();
  const handleClickOpen = () => {
    setFormOpen(true);
  }
  const handleClickClose = () => {
    setFormOpen(false);
  };
  useEffect(() => {
    //getShipListData(getCookie("clientId"));
    if (getCookie('type') !== "VPS Admin")
    {
      let getCookieval = "";
      if (localStorage.getItem('TOTFilterSetting') !== "" && localStorage.getItem('TOTFilterSetting') !== undefined && localStorage.getItem('TOTFilterSetting') !== null && localStorage.getItem('TOTFilterSetting') !== "null") {
        getCookieval = localStorage.getItem('TOTFilterSetting')
      }
      else {
        getCookieval = localStorage.getItem('GlobalFilterSetting')
      }
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      getFilterTransformers(Obj);

    } else {
      getFilterTransformers();
    }
  }
  else
  {
    let getCookieval = localStorage.getItem('GlobalFilterSetting');
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
     // getFilterTransformers();

  }
}
  }, []);
  const getShipListDataNew = () => {
    
    let getCookieval = localStorage.getItem('GlobalFilterSetting');
    if (getCookieval !== "" && getCookieval !== undefined && getCookieval !== "null") {
      let Obj = JSON.parse(getCookieval);
      getFilterTransformers(Obj);

    } else {
      getFilterTransformers();
    }

  }
  const seletedShipItemList = (row) => {
    //

    getCustomerContractData(row.transformerKey);
    getContractData(row.transformerKey);
    setSeletedShip(row);
  };

  const getShip = (value) => {
    //
    let local = seletedShip;
    local.transformerSamplingFrequency = value;
    //local[samplingFrequency] = value;

    // cetanelocal[field] = value;
    // setCetane({ ...cetane, ...cetanelocal });
  }

  const getShipListData = (customerKey) => {
    //
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Transformer/${customerKey}`;
    getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setShipList(res.data);
          getCustomerContractData(res.data[0].transformerKey);
          getContractData(res.data[0].transformerKey);
          setSeletedShip(res.data[index]);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  };

  const getCustomerContractData = (transformerKey) => {
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Transformer/ContractsDetails/${transformerKey}`;
    getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setCustomerContractList(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  };

  const getContractData = (transformerKey) => {
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Transformer/Contacts/${transformerKey}`;
    getRequest(url)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setContractList(res.data);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  };
  const getFilterDataByInput = (data) => {
    //console.log(data);
    getFilterTransformers(data);
  }
  const clearFilter = () => {
    //
    //getContractData()
    //getCustomerContractData()
    //seletedShipItemList()
    //getShipListData(getCookie("clientId"));
    getShipListDataNew();

  }

  const getFilterTransformers = (formObj) => {
    
    let filterObj = {};
    let Data = {};
    if (formObj !== "" && formObj !== undefined) {
      if (formObj.TotTransformerName && formObj.TotTransformerName.length > 0) { filterObj = { ...filterObj, TotTransformerName: formObj.TotTransformerName } }
      if (formObj.customerNameKey && formObj.customerNameKey.length > 0) { filterObj = { ...filterObj, customerNameKey: formObj.customerNameKey || null } }
      if (formObj.Totlocation && formObj.Totlocation.length > 0) { filterObj = { ...filterObj, Totlocation: formObj.Totlocation } }
      if (formObj.Totvoltage && formObj.Totvoltage.length > 0) { filterObj = { ...filterObj, Totvoltage: formObj.Totvoltage } }
      if (formObj.Totmanufacture && formObj.Totmanufacture.length > 0) { filterObj = { ...filterObj, Totmanufacture: formObj.Totmanufacture } }
      if (formObj.TotRating && formObj.TotRating && formObj.TotRating.length > 0) { filterObj = { ...filterObj, TotRating: formObj.TotRating } }
      if (formObj.TotSubCustomerName && formObj.TotSubCustomerName.length > 0) { filterObj = { ...filterObj, TotSubCustomerName: formObj.TotSubCustomerName } }
      if (formObj.TotUnitDescription && formObj.TotUnitDescription.length > 0) { filterObj = { ...filterObj, TotUnitDescription: formObj.TotUnitDescription } }
      if (formObj.Totserialnumber && formObj.Totserialnumber.length > 0) { filterObj = { ...filterObj, Totserialnumber: formObj.Totserialnumber } }
      const myJSONData = JSON.stringify(filterObj);
      Data = {
        Data: myJSONData,
      }
    }
    dispatch({ type: LOADING, payload: true });
    const url =
      process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
      `Transformer/Filter`;
    // for (let prop in data) {
    //   if (data[prop].trim() == "")
    //     delete data[prop];
    // }
    postRequest(url, Data)
      .then((res) => {
        //console.log(res);
        if (res.status == 200) {
          dispatch({ type: LOADING, payload: false });
          setShipList(res.data);
          getCustomerContractData(res.data[0].transformerKey);
          getContractData(res.data[0].transformerKey);
          setSeletedShip(res.data[0]);
        } else {
          ToastError(res.data.message);
        }
      })
      .catch((error) => {
        dispatch({ type: LOADING, payload: false });
        //console.log(error);
        // ToastError(error.response.data.message);
      });
  }
  // const getLocationDetailsFilter = () => {
  //   //console.log(formObj);
  //   getFilterDataByInput(formObj);
  // }

  return (
    <>
      <div>
      <Box component="div" className="pos_relative">
                      <Dialog
                        open={formOpen}
                        scroll={scroll}
                        aria-labelledby="scroll-dialog-title"
                        aria-describedby="scroll-dialog-description"
                         >
                        <DialogTitle id="scroll-dialog-title" color="white">Assets</DialogTitle>
                        <DialogContent dividers={scroll === 'paper'}>
                            <DialogContentText
                                id="scroll-dialog-description"
                                //ref={descriptionElementRef}
                                tabIndex={-1}
                            >
                               <p className="subtitle">Help On Filter Panel</p><br />
                               <img className="maxwidth100" src="/assets/images/Assets-Transformer-Filters.jpg"></img><br /><br />
                               <p>
                                  <li>Click and type on the fields to see the options</li><br/>
                                  <li>For multiple selections hold <img src={ctrl}  width="40px" height="40px"/> to select options from the list</li><br/>
                                  <li>Click <ClearIcon color="disabled"/> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px"/></li><br/>
                                  <li>Click <CancelIcon color="disabled"/> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px"/> </li><br/>
                                  <li>Click on <img src={applyfilter} alt="" width="100px" height="100px"/> to apply selected filters</li><br/>
                                  <li>Click on <img src={reset} alt="" width="70px" height="70px"/> will revert changes made in filter panel and set it to default global filter values</li><br/>
                                  <p><span style={{color:"#ff4717"}}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                                </p><br/>
                                <p className="subtitle">Help On Transformer Section</p><br />
                                <img className="maxwidth100" src="/assets/images/Assets-Transformer-Details.jpg"></img><br /><br />
                                <p>
                                  <li>Select Transformer from Transformer list in the left corner</li><br/>
                                  <li>Selected Transformer detail will display in Transformer details section</li><br/>
                                  <li>Enter sampling days in new sampling frequency to change the sampling frequency manually</li><br/>
                                  <li>Click on <img src={save}  width="70px" height="70px"/> save will save the edited sampling frequency</li><br/>
                                  <li>Click on <CheckBoxOutlineBlankIcon color="disabled"/>Ad hoc can hide the sampling frequency manually</li><br/>
                                </p>
                                <img className="maxwidth100" src="/assets/images/Assets-Contact-Details.jpg"></img><br /><br />
                                <p>
                                  <li>Selected Transformer contact details will display in Contact Details section</li><br/>
                                  <li>Selected Transformer customer and contract details will display in Customer and Contract Details section</li>
                                </p>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClickClose}>Close</Button>
                        </DialogActions>
                    </Dialog>
                    </Box>
                    </div>
    <Box component="div" px={2} className={classes.root}>
      <Grid container spacing={3} className={classes.gridSpacing}>
        <Grid className="breadcrum" item xs={12}>
          <BreadcrumbPage rows={BreadcrumbList} icon={<Help onClick={handleClickOpen}/>}/>
        </Grid>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <TransformerForm getFilterDataByInput={getFilterDataByInput} clearFilter={clearFilter} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={2}>
          {/* {shipList.length ? (
            <TransformerList
              seletedShipItemList={seletedShipItemList}
              shipList={shipList}
            />
          ) : (
            ""
          )} */}
          <TransformerList
            seletedShipItemList={seletedShipItemList}
            shipList={shipList}
            setIndex={setIndex}
          />
        </Grid>
        <Grid item xs={12} md={10}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TransformerDetails
                getShip={getShip}
                seletedShip={seletedShip}
              />
            </Grid>
            <Grid item xs={12}>
              <AlertContact transformerkey={seletedShip.transformerKey}/>
            </Grid>
            <Grid item xs={12}>
              <ContractDetails contractList={contractList} />
            </Grid>
            <Grid item xs={12}>
              <CustomerContractDetails
                customerContractList={customerContractList}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  </>
  );
}
